import { useEffect, useRef, useState } from "react";
import ModalGlobalTopbar from "../modalGlobalTopbar/ModalGlobalTopbar";
import style from "./ModalApps.module.css";
import TopbarItem from "./modalAppsItem/ModalAppsItem";
import { FaGraduationCap, FaUserGraduate } from "react-icons/fa";

function ModalApps({ mostrar, aoFechar, botaoRef }) {
  const modalRef = useRef(null);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });
  const [posicaoCalculada, setPosicaoCalculada] = useState(false); // controle

  const calcularPosicao = () => {
    if (botaoRef.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      const left = Math.min(rect.right - 205, window.innerWidth - 215); // margem de segurança
      const top = rect.bottom + 5;

      setPosicao({ top, left });
      setPosicaoCalculada(true);
    }
  };

  useEffect(() => {
    if (mostrar) {
      setPosicaoCalculada(false); // marca como não pronto

      // espera um ciclo de renderização
      setTimeout(() => {
        calcularPosicao();
      }, 0);

      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]);

  return (
    <ModalGlobalTopbar mostrar={mostrar} aoFechar={aoFechar} botaoRef={botaoRef}>
      {posicaoCalculada && (
        <div
          ref={modalRef}
          className={style.container_modal}
          style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
        >
          <div className={style.container_caminhos}>
            <TopbarItem
              link={process.env.REACT_APP_SITE_PORTAL}
              texto={"Portal do Aluno"}
              logo={<FaUserGraduate />}
              aoFechar={aoFechar}
            />
            <TopbarItem
              link={process.env.REACT_APP_SITE_PLATAFORMA}
              texto={"Plataforma"}
              logo={<FaGraduationCap />}
              aoFechar={aoFechar}
            />
          </div>
        </div>
      )}
    </ModalGlobalTopbar>
  );
}

export default ModalApps;
